import styled from "styled-components";

export const Screen = styled.div`
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: #3e5c3d;
`;